import { Button } from "@components/Button";
import { Flex } from "@components/Flex";
import { bp } from "@styles/theme";
import styled from "styled-components";
import { Typography } from "./Typography";
import { Form } from "formik";

export const Heading = styled.h1`
    margin-top: 0;
    color: ${props => props.theme.color.grayD};
    font-size: 25px;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 25px;

    ${bp.large} {
        font-size: 30px;
        line-height: 40px;
        margin-bottom: 30px;
    }
`;

export const LeftSide = styled(Flex.Container).attrs({
    $display: "block",
    $bpLarge: {
        $display: "flex",
        $alignItems: "center",
        $justifyContent: "center",
    },
})`
    order: 2;

    ${bp.large} {
        position: relative;
        min-height: 100%;
        left: 0;
        width: 50%;
    }
`;

export const LeftSideImage = styled.div<{ objectP: "center bottom" | "center" | "center top" }>`
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: none;

    ${bp.large} {
        display: block;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: ${props => props.objectP};
    }
`;

export const LeftSideContent = styled.div`
    position: relative;
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    padding: 40px 15px 0;
    border-top: 1px dashed ${props => props.theme.color.line};
    text-align: center;
    margin-bottom: 10%;

    p {
        margin-bottom: 20px;

        ${bp.large} {
            margin-bottom: 35px;
            font-size: 18px;
            line-height: 34px;
        }
    }

    ${bp.large} {
        border-top: none;
        padding: 0;
    }
`;

export const RightSide = styled(Flex.Container).attrs({
    $justifyContent: "center",
})`
    background: ${props => props.theme.color.beige};
    height: auto;
    padding: 50px 0;
    order: 1;

    ${bp.large} {
        padding: 80px 0;
        width: 50%;
    }

    ${bp.xxxlarge} {
        padding: 10% 0;
    }
`;

export const LoginContainer = styled(Flex.Container).attrs({
    $flexDirection: "column",
    $bpLarge: {
        $flexDirection: "row",
    },
})`
    flex: 1 0 auto !important;
    background: ${props => props.theme.color.beige};

    ${bp.large} {
        ${LeftSide} {
            order: 1;
        }

        ${RightSide} {
            order: 2;
        }
    }
`;

export const LoginForm = styled(Form)`
    width: 100%;
    max-width: 420px;
    padding: 0 16px;

    ${Typography.H2} {
        text-align: center;
        margin-bottom: 20px;
    }

    ${bp.large} {
        padding: 0;
    }

    .login-input {
        margin-bottom: 20px;

        ${bp.medium} {
            margin-bottom: 30px;
        }
    }
`;

export const LoginButton = styled(Button.Primary)`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 40px;

    ${bp.medium} {
        width: 250px;
        margin: 0 auto;
    }
`;

export const Separator = styled.div`
    position: relative;
    text-align: center;
    margin: 35px 0;

    &:before {
        content: "";
        display: block;
        width: 100%;
        height: 1px;
        background: ${props => props.theme.color.line};
        position: absolute;
        top: 11px;
        left: 0;
    }

    span {
        position: relative;
        display: inline-block;
        padding: 0 20px;
        background: ${props => props.theme.color.beige};
    }
`;

export const SocialButton = styled(Flex.Container).attrs({
    as: "button",
    $alignItems: "center",
})<{ platform: "facebook" | "apple" }>`
    border-radius: 5px;
    color: ${props => props.theme.color.white};
    background-color: ${props => (props.platform === "facebook" ? props.theme.color.contrastFacebook : props.theme.color.black)};
    font-size: 12px;
    line-height: 15px;
    font-weight: 500;
    height: 40px;
    padding: 0 20px;
    width: 100%;
    margin: 0 auto 15px;

    ${bp.medium} {
        width: 250px;
    }

    span {
        flex: 1;
    }
`;

export const FullScreenContainer = styled(Flex.Container).attrs({
    $alignItems: "center",
})`
    flex: 1 0 auto;
    padding: 60px 0;
    border-top: 1px dashed ${props => props.theme.color.line};
    border-bottom: 1px solid ${props => props.theme.color.line};

    ${Heading} {
        margin-bottom: 20px;
    }
`;

export const Content = styled(Flex.Container).attrs({
    $flexDirection: "column",
    $alignItems: "center",
})`
    max-width: 420px;
    margin: 0 auto;

    p {
        text-align: center;
    }

    img {
        margin-bottom: 30px;
    }
`;
